export interface TranslationMap {
  [language: string]: Record<string, string>;
}

export const TRANSLATIONS: TranslationMap = {
  en: {
    title: 'Search Procedures',
    subtitle: 'Find government procedures and services',
    trendingSearchesTitle: 'Popular searches',
    searchPlaceholder: 'Search...',
    clearSearch: 'Clear',
    domains: 'Domains',
    categories: 'Categories',
    annexes: 'Annexes',
    areas: 'Method of service provision',
    type: 'Type',
    availabilityType: 'Availability Type',
    county: 'County',
    city: 'City',
    availableOnline: 'Available Online',
    assistanceService: 'Assistance Service',
    annex: 'Annex',
    transnational: 'Cross-border',
    targetAudience: 'Target Audience',
    clearFilters: 'Clear all',
    filterTitle: 'Filters',
    resultsCount: '{count} results',
    noResults: 'No results found',
    errorLoading: 'Error loading results',
    errorLoadingFacets: 'Unable to load facet labels',
    loading: 'Loading...',
    selectedFilters: 'Selected filters',
    processingTime: 'Processing time: {ms} ms',
    pageOf: 'Page {current} of {total}',
    first: 'First',
    previous: 'Previous',
    next: 'Next',
    last: 'Last',
    facetSearchPlaceholder: 'Filter options...',
    showMore: 'Show more',
    showLess: 'Show less',
    noFacetResults: 'No options found',
    collapseFacet: 'Collapse',
    expandFacet: 'Expand',
    sortBy: 'Sort by',
    sortRelevance: 'Relevance',
    sortNameAsc: 'Name (A-Z)',
    sortNameDesc: 'Name (Z-A)',
    toggleFilters: 'Hide/Show filters',
    summaryOfWhich: 'of which',
    summaryAnd: 'and',
    proceduresCount: '{count} procedures',
    onlineCount: '{count} online',
    institutionsCount: '{count} institutions',
    informativePagesCount: '{count} informative pages',
    institutionServicesCount: '{count} services',
    institutionOnlinePercent: '{count}% online',
    institutionProceduresCount: '{count} procedures',
    institutionOnlineCount: '{count} online'
  },
  ro: {
    title: 'Căutare Proceduri',
    subtitle: 'Găsește proceduri și servicii guvernamentale',
    trendingSearchesTitle: 'Căutări populare',
    searchPlaceholder: 'Caută...',
    clearSearch: 'Șterge',
    domains: 'Domenii',
    categories: 'Categorii',
    annexes: 'Anexe',
    areas: 'Modalitate de prestare',
    type: 'Tip',
    availabilityType: 'Tip Disponibilitate',
    county: 'Județ',
    city: 'Localitate',
    availableOnline: 'Disponibil Online',
    assistanceService: 'Serviciu Asistență',
    annex: 'Anexă',
    transnational: 'Transfrontalier',
    targetAudience: 'Public Țintă',
    clearFilters: 'Șterge toate',
    filterTitle: 'Filtre',
    resultsCount: '{count} rezultate',
    noResults: 'Nu s-au găsit rezultate',
    errorLoading: 'Eroare la încărcare',
    errorLoadingFacets: 'Nu s-au putut încărca etichetele facete',
    loading: 'Se încarcă...',
    selectedFilters: 'Filtre selectate',
    processingTime: 'Timp de procesare: {ms} ms',
    pageOf: 'Pagina {current} din {total}',
    first: 'Prima',
    previous: 'Înapoi',
    next: 'Înainte',
    last: 'Ultima',
    facetSearchPlaceholder: 'Filtrează opțiunile...',
    showMore: 'Arată mai multe',
    showLess: 'Arată mai puține',
    noFacetResults: 'Nu s-au găsit opțiuni',
    collapseFacet: 'Restrânge',
    expandFacet: 'Extinde',
    sortBy: 'Sortează după',
    sortRelevance: 'Relevanță',
    sortNameAsc: 'Nume (A-Z)',
    sortNameDesc: 'Nume (Z-A)',
    toggleFilters: 'Ascunde/afișează filtre',
    summaryOfWhich: 'din care',
    summaryAnd: 'si',
    proceduresCount: '{count} proceduri',
    onlineCount: '{count} online',
    institutionsCount: '{count} institutii',
    informativePagesCount: '{count} pagini informative',
    institutionServicesCount: '{count} servicii',
    institutionOnlinePercent: '{count}% online',
    institutionProceduresCount: '{count} proceduri',
    institutionOnlineCount: '{count} online'
  }
};
